import React, { useState } from 'react';
import { HomeIcon, UsersIcon, MessageSquareTextIcon, SettingsIcon, MenuIcon, XIcon, BellIcon, UserIcon, PlusIcon } from 'lucide-react';
interface NavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  setActiveTab
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const tabs = [{
    id: 'dashboard',
    label: 'Home',
    icon: <HomeIcon size={18} data-id="element-673" />
  }, {
    id: 'people',
    label: 'Connections',
    icon: <UsersIcon size={18} data-id="element-674" />
  }, {
    id: 'messages',
    label: 'Messages',
    icon: <MessageSquareTextIcon size={18} data-id="element-675" />
  }, {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon size={18} data-id="element-676" />
  }];
  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    setMobileMenuOpen(false);
  };
  return <div className="bg-white border-b border-gray-200" data-id="element-677">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-678">
        <div className="flex justify-between h-16" data-id="element-679">
          {/* Logo */}
          <div className="flex" data-id="element-680">
            <div className="flex-shrink-0 flex items-center" data-id="element-681">
              <span className="text-xl font-bold text-gray-900" data-id="element-682">
                <span className="text-[#f9b30f]" data-id="element-683">LinkedIn</span> Intent Monitor
              </span>
            </div>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center" data-id="element-684">
            <div className="flex space-x-1" data-id="element-685">
              {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`inline-flex items-center px-3 py-2 border-b-2 text-sm font-medium ${activeTab === tab.id ? 'border-[#f9b30f] text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-686">
                  <span className="mr-2" data-id="element-687">{tab.icon}</span>
                  {tab.label}
                </button>)}
            </div>
            {/* User menu and actions */}
            <div className="ml-6 flex items-center space-x-4" data-id="element-688">
              <button className="p-1.5 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100" data-id="element-689">
                <BellIcon size={20} data-id="element-690" />
              </button>
              <div className="border-l border-gray-200 h-6 mx-2" data-id="element-691"></div>
              <button className="bg-[#f9b30f] hover:bg-[#e0a40e] text-white px-4 py-2 rounded-md text-sm font-medium flex items-center" data-id="element-692">
                <PlusIcon size={16} className="mr-1" data-id="element-693" />
                New Monitor
              </button>
              <button className="flex items-center" data-id="element-694">
                <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-300" data-id="element-695">
                  <UserIcon size={16} data-id="element-696" />
                </div>
              </button>
            </div>
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-697">
            <button className="p-1.5 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 mr-2" data-id="element-698">
              <BellIcon size={20} data-id="element-699" />
            </button>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none" data-id="element-700">
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-701" /> : <MenuIcon className="block h-6 w-6" data-id="element-702" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`md:hidden ${mobileMenuOpen ? 'block' : 'hidden'}`} data-id="element-703">
        <div className="pt-2 pb-3 space-y-1" data-id="element-704">
          {tabs.map(tab => <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`block w-full text-left px-3 py-2 text-base font-medium ${activeTab === tab.id ? 'text-[#f9b30f] bg-gray-50 border-l-4 border-[#f9b30f]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-705">
              <div className="flex items-center" data-id="element-706">
                <span className="mr-3" data-id="element-707">{tab.icon}</span>
                {tab.label}
              </div>
            </button>)}
          <div className="px-3 py-3" data-id="element-708">
            <button className="w-full bg-[#f9b30f] hover:bg-[#e0a40e] text-white px-4 py-2 rounded-md text-sm font-medium flex items-center justify-center" data-id="element-709">
              <PlusIcon size={16} className="mr-1" data-id="element-710" />
              New Monitor
            </button>
          </div>
          <div className="px-3 py-2 border-t border-gray-200 mt-2" data-id="element-711">
            <div className="flex items-center" data-id="element-712">
              <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600" data-id="element-713">
                <UserIcon size={16} data-id="element-714" />
              </div>
              <div className="ml-3" data-id="element-715">
                <div className="text-sm font-medium text-gray-700" data-id="element-716">
                  John Doe
                </div>
                <div className="text-xs text-gray-500" data-id="element-717">
                  john.doe@example.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};